<script setup lang="ts">

import { faArrowUpRightFromSquare } from '@fortawesome/pro-regular-svg-icons'

import { AppText } from '@shared/ui/typography'
import { RowSlot } from '@shared/ui/other'
import { BtnIcon } from '@shared/ui/buttons'

import AttendanceRateLabel from '../AttendanceRateLabel.vue'
import { useMainInfoAttendanceRate } from '../../model/use-main-info-attendance-rate.hook'
import { useTutorKanbanStore } from '../../model/store'

defineOptions({
  name: 'MainInfoAttendanceRate',
})

const tutorKanbanStore = useTutorKanbanStore()

const {
  refValue,
  handleClick,
} = useMainInfoAttendanceRate()
</script>

<template>
  <RowSlot label="Attendance rate">
    <div class="main-info-attendance-rate">
      <AppText name="body1-medium">
        {{ refValue }}
      </AppText>
      <AppText
        name="body1"
        color="slate-500"
        class="main-info-attendance-rate__max"
      >
        /100
      </AppText>
      <AttendanceRateLabel
        v-if="tutorKanbanStore.getTutor"
        :tutor="tutorKanbanStore.getTutor"
      />
      <BtnIcon
        :icon="faArrowUpRightFromSquare"
        color="blue"
        view="transparent"
        size="small"
        @click="handleClick"
      />
    </div>
  </RowSlot>
</template>

<style scoped lang="scss" src="./MainInfoAttendanceRate.scss" />
